var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHelpDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 24,
    height: 24,
    transform: "translate(1876 1776)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_help_docs",
    transform: "translate(-1876 -1776)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Question_-_Free_ui_icons-2",
    "data-name": "Question - Free ui icons-2",
    transform: "translate(1877.795 1777.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_2",
    "data-name": "Layer 2",
    d: "M20.585,4.683C19.126,3.02,15.995,2,12.2,2S5.274,3.02,3.816,4.683c-2.428,2.815-2.428,12.24,0,15.035C5.274,21.38,8.406,22.4,12.2,22.4s6.926-1.02,8.384-2.683c2.428-2.815,2.428-12.22,0-15.035ZM12.2,17.81a1.02,1.02,0,1,1,1.02-1.02A1.02,1.02,0,0,1,12.2,17.81Zm1.02-4.978v.9a1.02,1.02,0,0,1-2.04,0v-.949a1.928,1.928,0,0,1,1.357-1.867,1.163,1.163,0,1,0-1.5-1.122,1.02,1.02,0,1,1-2.04,0,3.213,3.213,0,0,1,6.263-.836,3.213,3.213,0,0,1-2.04,3.876Z",
    transform: "translate(-1.995 -2)",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelpDocs);
export default __webpack_public_path__ + "static/media/ic_help_docs.1585ffec3e7355e53986a1896bc0d932.svg";
export { ForwardRef as ReactComponent };